<div class="container auth-container">
  <div class="auth-card">
    <h2 class="auth-title">E-mail təsdiqi</h2>

    <div *ngIf="!linkSent; else successTemplate">
      <form [formGroup]="emailForm" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="form-group">
          <label for="email">E-mail</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            placeholder="E-mail ünvanınızı daxil edin"
            [class.invalid]="emailForm.get('email')?.invalid && emailForm.get('email')?.touched"
          >
          <div class="error-message" *ngIf="emailForm.get('email')?.invalid && emailForm.get('email')?.touched">
            <span *ngIf="emailForm.get('email')?.errors?.['required']">E-mail daxil edilməlidir.</span>
            <span *ngIf="emailForm.get('email')?.errors?.['email']">E-mail düzgün deyil.</span>
          </div>
        </div>

        <button type="submit" class="btn-submit" [disabled]="emailForm.invalid">Təsdiq linki göndər</button>
      </form>
    </div>

    <ng-template #successTemplate>
      <div class="success-message">
        <p>E-mailə təsdiq linki göndərildi. Zəhmət olmasa e-mailinizi yoxlayın.</p>
        <div class="resend-section">
          <button type="button" class="btn-resend" [disabled]="timer > 0" (click)="resendLink()">
            Təsdiq linkini yenidən göndər <span *ngIf="timer > 0">({{timer}}s)</span>
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
